import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Subject } from 'rxjs';

@Component({
  selector: 'nem-login',
  templateUrl: './login.comp.html',
  standalone: false,
  styles: [
    `
      ::ng-deep .amplify-theme-override [data-amplify-authenticator] {
        /* Couleurs primaires (Indigo V-NEM au lieu du vert AWS) */
        --amplify-colors-brand-primary-10: #eef2ff;
        --amplify-colors-brand-primary-80: #4f46e5;
        --amplify-colors-brand-primary-90: #4338ca;
        --amplify-colors-brand-primary-100: #3730a3;

        /* Couleurs des boutons et liens */
        --amplify-components-button-primary-background-color: var(--amplify-colors-brand-primary-80);
        --amplify-components-button-primary-hover-background-color: var(--amplify-colors-brand-primary-90);
        --amplify-components-button-link-color: var(--amplify-colors-brand-primary-80);
        --amplify-components-button-link-hover-color: var(--amplify-colors-brand-primary-90);

        /* Onglets (Sign In / Create Account) */
        --amplify-components-tabs-item-active-border-color: var(--amplify-colors-brand-primary-80);
        --amplify-components-tabs-item-active-color: var(--amplify-colors-brand-primary-80);

        /* Style de la carte (Ombres plus douces, bords plus ronds, pas de bordure dure) */
        --amplify-components-authenticator-router-box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.05),
          0 8px 10px -6px rgba(0, 0, 0, 0.01);
        --amplify-components-authenticator-router-border-width: 1px;
        --amplify-components-authenticator-router-border-color: #f1f5f9;
        --amplify-radii-xl: 1.25rem;
        --amplify-radii-small: 0.5rem;

        /* Typographie et Inputs */
        --amplify-fonts-default: 'Inter', system-ui, sans-serif;
        --amplify-components-fieldcontrol-border-color: #e2e8f0;
        --amplify-components-fieldcontrol-focus-box-shadow: 0 0 0 2px var(--amplify-colors-brand-primary-10);
      }
    `
  ]
})
export class LoginComponent implements OnInit, OnDestroy {
  private _destroy$ = new Subject<void>();

  services = {
    // @ts-ignore
    async validateCustomSignUp(formData: Record<string, string>) {
      if (!formData['acknowledgement']) {
        return {
          acknowledgement: 'You must agree to the Terms & Conditions'
        };
      }
      if (!formData['given_name']) {
        return {
          acknowledgement: 'Organisation is required'
        };
      }
      if (!formData['name']) {
        return {
          acknowledgement: 'Name is required'
        };
      }
    }
  };

  formFields = {
    signUp: {
      given_name: {
        order: 1,
        isRequired: true
      },
      name: {
        order: 2,
        isRequired: true
      },
      email: {
        order: 3
      },
      password: {
        order: 4
      }
    }
  };

  get authenticated() {
    return this._authenticator.authStatus == 'authenticated';
  }

  get configuring() {
    return this._authenticator.authStatus === 'configuring';
  }

  openTerms() {
    window.open('/assets/terms_conditions_and_privacy.pdf', '_blank');
  }

  constructor(private _authenticator: AuthenticatorService, private _router: Router) {}

  ngOnInit() {
    this._authenticator.subscribe(state => {
      if (state.authStatus === 'authenticated') {
        this._router.navigate(['/dashboard/regional']);
      }
    });
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
